module.exports = "<p>\n  root works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/layouts/root/root.component.html
// module id = ../../../../../src/app/@hornbillfx/layouts/root/root.component.html
// module chunks = main